import { useState } from 'react';

export const UseVerifyMFAForm = () => {
    const [formData, setFormData] = useState({
        mfaVerificationData: null,
        mfaVerificationCode: '',
        isValid: false,
        isMFAVerifying: false
    });

    const handleCodeChange = (e) => {
        const mfaVerificationCode = e.target.value;
        setFormData(prev => ({
            ...prev,
            mfaVerificationCode,
            isValid: mfaVerificationCode.length === 6
        }));
    };

    const setMFAVerificationData = (mfaVerificationData) => {
        setFormData(prev => ({
            ...prev,
            mfaVerificationData
        }));
    };

    const setMFAVerifying = (isMFAVerifying) => {
        setFormData(prev => ({
            ...prev,
            isMFAVerifying
        }));
    };

    const reset = () => {
        setFormData({
            mfaVerificationData: null,
            mfaVerificationCode: '',
            isValid: false,
            isMFAVerifying: false
        });
    };

    return {
        formData,
        handleCodeChange,
        setMFAVerificationData,
        setMFAVerifying,
        reset
    };
};